import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ProfileSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M16.1992 27.4915333c-3.9033333 0-7.35533333-1.9993333-9.37-5.0286666.04733333-3.1073334 6.2466667-4.8093334 9.37-4.8093334 3.108 0 9.3226667 1.702 9.37 4.8093334-2.0146667 3.0293333-5.466 5.0286666-9.37 5.0286666m0-22.1753333c2.5926667 0 4.6846667 2.09266667 4.6846667 4.6853333 0 2.592-2.092 4.6846667-4.6846667 4.6846667s-4.6846667-2.0926667-4.6846667-4.6846667c0-2.59266663 2.092-4.6853333 4.6846667-4.6853333m0-4.68533333c-8.62 0-15.61666667 6.99666666-15.61666667 15.61666663 0 8.62 6.99666667 15.6166667 15.61666667 15.6166667 8.6206667 0 15.6166667-6.9966667 15.6166667-15.6166667 0-8.61999997-6.996-15.61666663-15.6166667-15.61666663"
        />
      </g>
    </svg>
  )
}

ProfileSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
